export default "__VITE_ASSET__Ck_hT_yL__"